var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCritical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15548",
    transform: "translate(-20 -10)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(20 10)",
    fill: "#e52b24"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15828",
    transform: "translate(38.5 20.813)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1.5 12V0"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 15.375)",
    fill: "#fff"
  })))));
}

export default SvgCritical;